import { useRef, useCallback } from 'react';

/**
 * Hook для сохранения и восстановления позиции скролла
 * Используется для предотвращения автоматического скролла к началу при обновлении данных
 */
export const useScrollPosition = () => {
  const scrollPosition = useRef(0);

  /**
   * Сохраняет текущую позицию скролла
   */
  const saveScrollPosition = useCallback(() => {
    scrollPosition.current = window.pageYOffset || document.documentElement.scrollTop;
  }, []);

  /**
   * Восстанавливает сохраненную позицию скролла
   * @param {number} delay - Задержка перед восстановлением (мс)
   */
  const restoreScrollPosition = useCallback((delay = 0) => {
    if (delay > 0) {
      setTimeout(() => {
        window.scrollTo(0, scrollPosition.current);
      }, delay);
    } else {
      window.scrollTo(0, scrollPosition.current);
    }
  }, []);

  /**
   * Выполняет действие с сохранением позиции скролла
   * @param {Function} action - Асинхронное действие
   */
  const executeWithScrollPreservation = useCallback(async (action) => {
    saveScrollPosition();
    try {
      const result = await action();
      // Восстанавливаем позицию после небольшой задержки, чтобы DOM успел обновиться
      restoreScrollPosition(50);
      return result;
    } catch (error) {
      // Даже при ошибке восстанавливаем позицию
      restoreScrollPosition(50);
      throw error;
    }
  }, [saveScrollPosition, restoreScrollPosition]);

  return {
    saveScrollPosition,
    restoreScrollPosition,
    executeWithScrollPreservation
  };
};
